// eslint-disable-next-line @typescript-eslint/no-unused-vars
import SpotifyWebApi from "spotify-web-api-js";

// Enums
export enum RepeatState {
    off = "off",
    track = "track",
    context = "context",
}

// Interfaces
export interface SpotifyTokenResponse {
    access_token: string;
    expires_in: number;
    refresh_token: string;
    scope: string;
    token_type: string;
}

export interface SpotifyRefreshTokenResponse {
    access_token: string;
    expires_in: number;
    scope: string;
    token_type: string;
}

export interface DisallowsObject {
    interrupting_playback?: boolean;
    pausing?: boolean;
    resuming?: boolean;
    seeking?: boolean;
    skipping_next?: boolean;
    skipping_prev?: boolean;
    toggling_repeat_context?: boolean;
    toggling_repeat_track?: boolean;
    toggling_shuffle?: boolean;
    transferring_playback?: boolean;
}
export interface SWAActions {
    disallows: DisallowsObject;
}

export interface CurrentlyPlayingObjectWithExtras
    // eslint-disable-next-line no-undef
    extends SpotifyApi.CurrentlyPlayingObject {
    actions?: SWAActions;
    // eslint-disable-next-line no-undef
    repeat_state: SpotifyApi.PlaybackRepeatState;
    shuffle_state: boolean;
}
